import { SelectionChangedEvent } from "ag-grid-community";
import { EMPTY_PROPOSAL_COPY_FOR_RECAL_SEARCH_CRITERIA } from "domain/entity/ProposalCopyingForRecal/ProposalCopyingForRecalSearchCriteria";
import { INITIAL_PROPOSAL_COPY_FOR_RECAL_COL_DEF, transferRowData } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalColumnDefinition";
import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Core } from "veronica-ui-component";
import { GroupButtons, Loader } from "veronica-ui-component/dist/component/core";


const ProposalCopyingForRecalTablePanel: React.FC = () => {
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const { isShowTariffItemPanel, searchStatus, isForRecal, isForRecalCount, proposalCopyingForRecalList } = proposalCopyingForRecalState;
    const gridRef: any = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Table;
    const messageBarVM = useMessageBarVM();

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        proposalCopyingForRecalVM.updateSelectedRows(selectedRows);
    }, [proposalCopyingForRecalVM])

    const handleGroupButtonClick = useCallback(async (buttonId: string) => {
        setIsLoading(true);
        if (searchStatus && buttonId === searchStatus) {
            let newSearchCriteria = null;
            newSearchCriteria = { ...EMPTY_PROPOSAL_COPY_FOR_RECAL_SEARCH_CRITERIA }
            await proposalCopyingForRecalVM.searchProposalsForRecal(newSearchCriteria).then((data) => {
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
            }).finally(() => {
                setIsLoading(false);
            })
        } else {
            await proposalCopyingForRecalVM.onGroupButtonClick(buttonId).then((data) => {
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
            }).finally(() => {
                setIsLoading(false);
            })
        }

    }, [proposalCopyingForRecalVM, searchStatus]);


    // const handleSearchClick = useCallback(() => {
    //     proposalCopyingForRecalVM.onSearchClick();
    // }, [proposalCopyingForRecalVM]);


    // const tbBtns = useMemo(() => {
    //     let btns = [];
    //     !isShowTariffItemPanel && btns.push({
    //         id: 'onSearchButton',
    //         icon: 'Icon-search',
    //         title: 'Search',
    //     })
    //     return btns;
    // }, [isShowTariffItemPanel])

    const template = useMemo(() => {
        return (
            <>
                <Core.CheckButton
                    checked={isForRecal}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleGroupButtonClick(e.target.id) }}
                    showBadge={true}
                    badgeValue={isForRecalCount > 999 ? '999+' : isForRecalCount}
                    disabled={isForRecalCount === 0}
                    size="medium"
                    inputId="isForRecal"
                    label={SCREEN_CONSTANT.FOR_RECAL_BUT}
                />
            </>
        )
    }, [SCREEN_CONSTANT.FOR_RECAL_BUT, handleGroupButtonClick, isForRecal, isForRecalCount])

    const isRowSelectable = useCallback((params: any) => {
        return !isShowTariffItemPanel;
    }, [isShowTariffItemPanel]);

    const memoStandardProposalTable = useMemo(() => {

        return (
            <NbisTable
                id='proposal-copying-for-recal-table'
                isNewColumnSetting={true}
                columns={INITIAL_PROPOSAL_COPY_FOR_RECAL_COL_DEF?.slice()}
                data={transferRowData(proposalCopyingForRecalList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={true}
                rowSelection={"single"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight={/*isShowTariffItemPanel ? "calc(100vh - 145px)" : */"calc(100vh - 125px)"}
                ref={gridRef}
                // headerActionButtons={tbBtns}
                // onSearchButton={handleSearchClick}
                headerLabel={
                    <GroupButtons
                        alignment="single-selection"
                        errorMessage=""
                        label=""
                        children={template}
                    />
                }
                messageVM={messageBarVM}
                handleRowSelectable={isRowSelectable}
            />
        );
    }, [handleSelectionChange, isRowSelectable, messageBarVM, proposalCopyingForRecalList, template])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowTariffItemPanel])

    return <><TableWrapper>
        {(proposalCopyingForRecalState.isLoading || isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoStandardProposalTable}
    </TableWrapper>
    </>;
}

export default memo(ProposalCopyingForRecalTablePanel);
